import React from "react";
import { ViewTreatMent } from "../../../secondary";

export const createTreatmentComponent = (useHook, noDataMessage) => ({ interventionId, formularyId }) => {
  const { editData, viewData, doSubmit } = useHook({ interventionId, formularyId });
  return <ViewTreatMent editData={editData} viewData={viewData} saveData={doSubmit} noDataMessage={noDataMessage} />;
};
